<template>
  <div class="input">
    <!-- <label
    class="input-file"
    for="image"> -->
    <input
    :id="`${id}-url`"
    :name="`${id}-url`"
    class="link-input"
    type="text"
    :placeholder="placeholder"
    v-model="fileName"
    :disabled="inputDisabled">
    <i
    v-if="isValid || allowDelete"
    class="cui-trash"
    @click="setFile"></i>
    <label
    class="input-file"
    :for="id">
      {{label}}
    </label>
    <input
    type="file"
    :id="id"
    :name="id"
    :accept="type"
    ref="FileUploader"
    @change="setFile">
  </div>
</template>

<script>
import File_Helper from "@/lib/file_helper.js";
import { debug } from 'util';

export default {
  name: 'FileUploader',
  props: {
    id: {
      default: "image"
    },
    placeholder: {
      type: String,
      default: "Write content"
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: ""
    },
    validate: {
      type: String,
      default: ""
    },
    inputDisabled: {
      type: Boolean,
      default: true
    },
    fileUrl: {
      default: null
    },
    allowDelete: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      required: false,
    },
  },
  // props: ["placeholder", "label", "type", "validate", "inputDisabled", "articleImage"],
  data () {
    return {
      isValid: false,
      fileName: this.fileUrl || null
    }
  },
  watch: {
    fileUrl: function(newValue) {
      this.fileName = newValue;
    },
    clear:function(newValue){
      if(newValue){
        this.$refs.FileUploader.value = null;
        this.isValid = false;
        this.fileName = null;
        this.$emit("setFile", null);
      }
    }
  },
  methods: {
    setFile: async function(event) {
      const imgService = new File_Helper();
      if (event.target.files) {
        const file = event.target.files[0];
        if (!this.validate || file.type.includes(this.validate)) {
          // const imgDimension = await imgService.getImageDimension(file);
          // console.log(imgDimension);
          this.isValid = true;
          this.fileName = file.name;
          // console.log(file);
          this.$emit("setFile", file);
        }
      } else {
        this.$refs.FileUploader.value = null;
        this.isValid = false;
        this.fileName = null;
        this.$emit("setFile", null);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  // margin-left: 10px;
  display: flex;
  align-items: center;
  width: 100%;

  .link-input {
    width: 100%;
  }
  label.input-file {
    @extend %audi;
    font-size: 14px;
    color: $bg_1;
    margin-left: 15px;
    border-bottom: 1px solid $bg_1;
    cursor: pointer;
  }

  i {
    margin-bottom: 9px;
    margin-left: 4px;
    cursor: pointer;
  }

  #image {
    display: none;
  }
  input:not([id$=-url]) {
    display: none;
  }
}
</style>